import React from 'react';

import Box from '@amzn/meridian/box';
import Select, { SelectOption } from '@amzn/meridian/select';
import Text from '@amzn/meridian/text';

const OPTIONS = Array.from({ length: 9 }, (_, i) => ({
  label: `${i + 1}`,
  value: i + 1,
}));
interface FrequencySelectorProps {
  selectedValue: number | undefined;
  onSelectValue: (value: number) => void;
  errorMessage: string | undefined;
  isDisabled: boolean;
  /** @testOnly */
  index: number;
}
const FrequencySelector = ({
  selectedValue,
  onSelectValue,
  isDisabled,
  errorMessage,
  index,
}: FrequencySelectorProps) => {
  // This component does not make sense outside of the context of MeasureUnitValues.Hours
  // since we are quantizing all available selection values to be one hour increments
  // which may not be applicable to other measureUnit types. So "Hours" in hardcoded.

  return (
    <Box>
      <Text data-testid="new-jmr__npl__field-label">Frequency per Shift</Text>
      <Select
        aria-label="Frequency per Shift"
        data-cy={`new-jmr__restrictions__frequency-selector__dropdown__${index}`}
        placeholder="Select frequency"
        value={selectedValue}
        onChange={onSelectValue}
        errorMessage={errorMessage}
        error={!!errorMessage}
        disabled={isDisabled}
      >
        {OPTIONS.map((option, index) => (
          <SelectOption
            label={option.label}
            value={option.value}
            key={index}
            data-cy="new-jmr__frequency-selector__dropdown-item"
            data-testid="new-jmr__frequency-selector__dropdown-item"
          />
        ))}
      </Select>
    </Box>
  );
};

// **** Export **** //

export default FrequencySelector;
